import React, {Component}  from 'react';
import {Route, Switch} from 'react-router-dom';
import {view as LookOverQuestion} from './look_over_question'
import {view as QuestionCar} from './look_over_question/question_car'
//题目管理打标签
import { view as QuestionSetTag } from './look_over_question/question_set_tag'
import {view as ExplainList} from './question_explain/explain_task_list'
import {view as ExplainDetail} from './question_explain/eplain_detail'
import {view as ErrorDuty} from './question_explain/error_duty'//检错追责
/** 打标签 */
import { view as SetTagList } from './set_tag/tag_task_list'
import { view as TaskSetTag } from './set_tag/set_tag'
import { view as TaskCheckTag } from './set_tag/check_tag'
import { view as TaskLookTag } from './set_tag/look_tag'


import {view as EvaluatingList} from './question_evaluating/evaluating_task_list'
import {view as EvaluatingDetail} from './question_evaluating/evaluating_detail'

// import { view as TaskSetTagCheck } from './set_tag/tag_task_list'
/** 打标签 */
import { view as QuestionExport } from './question_export'
import { view as Bulkimport } from './bulk_Import'
/** 图片订正**/
import { ImageCorrectionList  } from './image_correction'
import { view as imageCorrectionDetail } from './image_correction/image_correction_detail'
/** 审查超纲**/
import { CheckBeyondLevelList,CheckBeyondLevelDetail } from './check_beyond_level'
/** 题型模版 **/
import { QuestionTempList} from './question_tml';
/** 题目日志 **/
import {QuestionRecord} from './look_over_question/question_record'


class QuestionBox extends Component{
    render(){
        return(
                <div style={{height:"100%"}}>
                    <Switch>
                        <Route exact path="/questionmanage/lookoverquestion" component={LookOverQuestion}/>
                        <Route exact path="/questionmanage/lookoverquestion/questioncar" component={QuestionCar}/>
                        <Route exact path="/questionmanage/lookoverquestion/questionRecord" component={QuestionRecord}/>
                        <Route exact path="/questionmanage/lookoverquestion/setTag/(.*)" component={QuestionSetTag}/>

                        {/*题目解析*/}
                        <Route exact path="/questionmanage/questionexplain" component={ExplainList}/>
                        <Route exact path="/questionmanage/questionexplain/explaindetail/(.*)" component={ExplainDetail}/>
                        <Route exact path="/questionmanage/questionexplain/duty/(.*)" component={ErrorDuty}/>
                        {/* 打标签 */}
                        <Route exact path="/questionmanage/settag" component={SetTagList}/>
                        <Route exact path="/questionmanage/settag/tasksettag/(.*)" component={TaskSetTag}/>
                        <Route exact path="/questionmanage/settag/taskchecktag/(.*)" component={TaskCheckTag}/>
                        <Route exact path="/questionmanage/settag/tasklooktag/(.*)" component={TaskLookTag}/>

                        {/* 题目批量导入 */}
                        <Route exact path="/questionmanage/bulkimport" component={Bulkimport}/>
                        {/* 题目导出 */}
                        <Route exact path="/questionmanage/questionExport" component={QuestionExport}/>

                        {/*题目评测*/}
                        <Route exact path="/questionmanage/questionevaluating" component={EvaluatingList}/>
                        <Route exact path="/questionmanage/questionevaluating/evaluatingdetail/(.*)" component={EvaluatingDetail}/>
                         {/*图片订正*/}
                        <Route exact path="/questionmanage/imageCorrection" component={ImageCorrectionList}/>
                        <Route exact path="/questionmanage/imageCorrection/detail/(.*)" component={imageCorrectionDetail}/>
                         {/*超纲审查*/}
                        <Route exact path="/questionmanage/checkBeyondLevel" component={CheckBeyondLevelList}/>
                        <Route exact path="/questionmanage/checkBeyondLevel/detail/(.*)" component={CheckBeyondLevelDetail}/>
                        {/* 题型模版 */}
                        <Route exact path="/questionmanage/questionTemplate" component={QuestionTempList}/>
                    </Switch>
                </div>
        );
    }
}
export default QuestionBox



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/view.js